// ==========================================
// STANDARD TEMPLATES
// ==========================================
// Reusable display templates for common patterns.
// Use these to ensure consistent rendering across representations.

/** Standard template for calculation results: notation = expression = value */
export const CALCULATION_RESULT_TEMPLATE = '{{notation}} = {{expression}} = {{value}}';

/** Standard template for state/status displays with description */
export const STATE_TEMPLATE = '**{{state}}**: {{description}}';

/** Standard template for simple status displays (status only, no description) */
export const STATUS_TEMPLATE = '{{status}}';
